import React from 'react';
import UserModule from '../Users/UserModule';
import { useAuth } from '../../AuthContext';
import FacultyProfile from './FacultyProfile';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams } from 'react-router-dom';

function Faculty({ orgId, isKvFaculty }) {
  const { userRole, user, loading } = useAuth();
  const { type } = useParams();

  // If the user is a faculty member, show their own profile directly, unless they navigated to KV faculty
  if (userRole === 'FACULTY' && !isKvFaculty) {
    if (loading) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <CircularProgress />
        </div>
      );
    }
    if (!user) {
      return (
        <div style={{ padding: 20, color: 'red' }}>
          Profile not found
        </div>
      );
    }
    return (
      <div style={{ padding: 10 }}>
        <FacultyProfile selectedUser={user} />
      </div>
    );
  }

  // Otherwise, show the full user management module
  return <UserModule userType="FACULTY" orgId={orgId} isKvFaculty={isKvFaculty} fixedFacultyType={type} />;
}

export default Faculty;